import React, {useState, useEffect, useMemo} from 'react'
import { Select, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem} from '@mui/material'
import supabase from '../../../supabaseClient'
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';


function AttendanceAddNewRecord({open, onClose, currentTime, onRefresh, idConfig, lockedEmployeeId, lockedEmployeeName}){

//selector pracowników
    const [employees, setEmployees] = useState([])
    const [selectedEmployee, setSelectedEmployee] = useState('')

//aktualna data (do uzycia w formularzu) 
const t = new Date(); 
const today = `${t.getFullYear()}-${String(t.getMonth()+1).padStart(2,'0')}-${String(t.getDate()).padStart(2,'0')}`

//Zapis pól z formularza
    const[checkIn, setCheckIn] = useState('')
    const[checkOut, setCheckOut] = useState('')
    const[checkInDay, setCheckInDay] = useState(today)
    const[checkOutDay, setCheckOutDay] = useState(today)

    const checkInValue = useMemo(() => dayjs(checkInDay), [checkInDay])
    const checkOutValue = useMemo(() => dayjs(checkOutDay), [checkOutDay])

//pobranie kartoteki pracowników
useEffect(()=>{
    if(!open) return;

    if(lockedEmployeeId){
        setSelectedEmployee(lockedEmployeeId)
        return;
    }

    const fetchEmployees = async () => {
        const {data, error} = await supabase
        .from('employees')
        .select('id, name, surname')
        .eq('id_configuration', idConfig )
        .is('archived', null)

        if(error){
            console.log(error)
        }else{setEmployees(data)}
    }
    fetchEmployees()
    }, [open, lockedEmployeeId]);

//Zapis obecności do bazy
    const handleSave = async () => {
        const today = new Date();
        const todayString = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`

        const newCheckIn = new Date(`${checkInDay}T${checkIn}`).toISOString();
        const newCheckOut = checkOut ? new Date(`${checkOutDay}T${checkOut}`).toISOString() : null;

        const {error} = await supabase
            .from('attendance')
            .insert({
                employee_id: selectedEmployee,
                check_in: newCheckIn,
                check_out: newCheckOut,
                id_configuration: idConfig,
                type: 'work'
            })
            if (error){
                console.log(error)
            } else {
                onRefresh();
                onClose();
             }
    }
   
    return(
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Dodaj wpis</DialogTitle>
                <DialogContent>
                    {lockedEmployeeId ? (
                        <TextField
                            fullWidth
                            sx={{mt:2}}
                            label="Pracownik"
                            value={lockedEmployeeName || ''}
                            disabled
                        />
                    ) : (
                        <Select
                            fullWidth
                            sx={{mt:2}}
                            value={selectedEmployee}
                            onChange={(e) => setSelectedEmployee(e.target.value)}
                            displayEmpty
                            renderValue={(selected) => {
                                if (!selected) {
                                    return <span style={{ color: 'gray' }}>Wybierz pracownika</span>;
                                }
                                const employee = employees.find(e => e.id === selected);
                                return employee ? `${employee.name} ${employee.surname}` : '';
                            }}
                        >
                            {employees.map(employee =>
                                <MenuItem key={employee.id} value={employee.id}>
                                    {employee.name} {employee.surname}
                                </MenuItem>
                            )}
                        </Select>
                    )}

                <TimePicker
                    label="Godzina wejścia"
                    ampm={false}
                    sx={{ width: '100%', mt: 2 }}
                    value={checkIn ? dayjs(checkIn, 'HH:mm') : null}
                    onChange={value => setCheckIn(value && value.isValid() ? value.format('HH:mm') : '')}
                />

                <DatePicker
                    label='Dzień wejścia'
                    format="DD-MM-YYYY"
                    value={checkInValue}
                    onChange={value => {
                        if (value && value.isValid()) {
                            setCheckInDay(value.format('YYYY-MM-DD'));
                        }
                    }}
                    sx={{
                        mt: 2,
                        width:'100%'
                }}/>

                <TimePicker
                    label="Godzina wyjścia"
                    ampm={false}
                    sx={{ width: '100%', mt: 2 }}
                    value={checkOut ? dayjs(checkOut, 'HH:mm') : null}
                    onChange={value => setCheckOut(value && value.isValid() ? value.format('HH:mm') : '')}
                />

                <DatePicker
                    label='Dzień wyjścia'
                    format="DD-MM-YYYY"
                    value={checkOutValue}
                    onChange={value => {
                        if (value && value.isValid()) {
                            setCheckOutDay(value.format('YYYY-MM-DD'));
                        }
                    }}
                    sx={{
                        mt: 2,
                        width:'100%'
                }}/>

                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Anuluj</Button>
                    <Button 
                        variant='contained' 
                        onClick={() => { handleSave(); }}
                        disabled={!selectedEmployee || !checkIn || checkIn === '00:00'}
                    >Zapisz
                    </Button>
                </DialogActions>
        </Dialog>
    )
}



export default AttendanceAddNewRecord;